<template>
  <div class="card">
    <div class="card-image">
      <figure class="image is-4by3">
        <img v-bind:src="user.spaceship_image" alt="Spaceship">
      </figure>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-left">
          <figure class="image is-48x48">
            <img v-bind:src="user.avatar" alt="Avatar">
          </figure>
        </div>
        <div class="media-content">
          <p class="title is-5">{{ user.name }}</p>
          <p class="subtitle is-7">@{{ user.username }}</p>
        </div>
      </div>

      <div class="content">
        <b-progress 
          type="is-primary"
          size="is-small" 
          :value="user.ship.current_strength"
          :max="user.ship.strength"
          show-value
        ></b-progress>
        <template v-if="user.username =='hero'">
          <p>
            <progress 
              class="progress is-small is-primary" 
              v-bind:value="currentPower" 
              v-bind:max="currentMaxPower"
            ></progress>
          </p>
          <b-switch
            v-for="weapon in weapons"
            v-bind:key="weapon.id"
            v-model="weapon.enabled"
            size="is-small"
            type="is-danger"
            v-bind:disabled="weapon.enabled === false && (currentPower - weapon.power_consumption) < 0"
          >{{ weapon.name }}{{ weapon.stock ? ` (${weapon.stock})` : '' }}</b-switch>
          <hr>
          <b-switch
            v-for="protector in protections"
            v-bind:key="protector.id"
            v-model="protector.enabled"
            size="is-small"
            type="is-success"
            v-bind:disabled="protector.enabled === false && (currentPower - protector.power_consumption) < 0"
          >{{ protector.name }}{{ protector.stock ? ` (${protector.stock})` : '' }}</b-switch>
          <hr>
          <b-switch
            v-bind:disabled="true"
            size="is-small"
            type="is-dark"
          >Активное маневрирование</b-switch>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ShipService from '../services/TestBattleShipService'
export default {
  props: ['user'],
  data: function () {
    return {
      // currentStrength: this.user.ship.current_strength,
    }
  },
  computed: {
    currentStrength: function () {
      if (this.user.ship.current_strength > this.user.ship.strength * 0.5) {
        return 'is-success'
      } else if (this.user.ship.current_strength > this.user.ship.strength * 0.2) {
        return 'is-warning'
      } else {
        return 'is-danger'
      }
    },
    currentMaxPower: function () {
      return ShipService.calculatePowerGeneration(this.user.ship.devices)
    },
    currentConsumption: function () {
      return ShipService.calculatePowerConsumption(this.user.ship.devices) || 0
    },
    currentPower: function () {
      return this.currentMaxPower - this.currentConsumption
    },
    weapons: function() {
      return ShipService.weapons(this.user.ship)
    },
    protections: function() {
      return ShipService.protections(this.user.ship)
    }
  },
  methods: {
  },
}
</script>
